<template>
  <div class="body1">
    <div class="content">
      <div>
        <img class="img" src="../../assets/eblock-04.png">
        <div class="title bold">
          The prestigious WSA Award from<br/>
          the United Nations for<br/>
          the Best E-learning Solution
        </div>
      </div>
      <div class="right-wrapper">
        <div class="title large">
          THE AWARDS
        </div>
        <div class="title p">
          E-Blocks has been awarded and nominated for multiple international<br/> awards. In 2005 E-Blocks received the prestigious WSA Award from the<br/> United Nations for the Best E-learning Solution. In 2006, E-Blocks gained<br/> further recognition by winning four awards: The BESSIE Award for Early<br/> Elementary EFL Solutions and The EDDIE Award, for Best Software in Early<br/> Elementary; and two awards from the Association of Education Publishers<br/> (AEP): The Golden Lamp, and The Distinguished Achievement Award. <br/>E-Blocks Math was one of the five finalist in the 2008 CODiE Awards in two<br/> important categories: "Best Instructional Solution for Special Needs<br/> Students" and "Best Mathematics Instructional Solution.” In 2008, E-Blocks<br/> is been honored with the most recognized international prize in the<br/> education sector: The Worlddidac Award.
        </div>
        <img class="bg" src="../../assets/eblock-041.png">
      </div>
    </div>
    <div class="content">
      <img class="img2" src="../../assets/eblock-05.png">
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  mounted() {
  },
  methods: {}
}
</script>

<style scoped lang="less">
@import "../../assets/style/index";
.body1{
  height: 753px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #6D43A1;

  .content{
    .media-content;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    .img2{
      height: 184px;
      width: 994px;
      margin-top: 20px;
      object-fit: cover;
    }
    .title{
      margin-top: 24px;
      text-align: left;
      color: white;
      font-size: 18px;
      font-family: 'Adobe Heiti Std', Helvetica, Arial, sans-serif;
      line-height: 30px;
    }
    .bold{
      font-weight: bold;
    }
    .large{
      font-size: 30px !important;
    }
    .img{
      width: 293px;
      object-fit: contain;
      height: 126px;
    }
    .right-wrapper{
      margin-left: 20px;
      position: relative;
      .bg{
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        object-fit: contain;
        opacity: 0.3;
      }
      .p{
        padding: 0 15px;
        box-sizing: border-box;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/eblocks/e-body3.vue